import { AudioService } from '@/services/AudioService';
import { SlideAction, SlideProps, SlideStatePayload } from './props';

const initialState: SlideProps = {
  numberCarousel: [],
  chosenMultiplier: 2,
  prizeIndex: 0,
  resultMultiplier: null,
  round: null,
  closedRound: false,
  init: false,
  isSocketConnected: false,
};

export default function reducer(
  state: SlideProps = initialState,
  action: SlideStatePayload,
): SlideProps {
  switch (action.type) {
    case SlideAction.GetTargetMultiplier:
      return {
        ...state,
        chosenMultiplier: action.payload,
      };
    case SlideAction.SetRound: {
      if (!state.round || state?.round?.id != action.payload.id) {
        //@ts-ignore
        return {
          ...state,
          round: action.payload,
          init: false,
          closedRound: false,
        };
      } else {
        return {
          ...state,
          round: action.payload,
          init: false,
        };
      }
    }

    case SlideAction.HandleStoppedSlide:
      if (!AudioService.isGamesMuted()) {
        const getMultiplierSound = () => {
          if (state.resultMultiplier == null) {
            return '0x';
          }

          if (+state.resultMultiplier < 1.99) {
            return '0x';
          }

          if (+state.resultMultiplier < 4.99) {
            return '2x';
          }

          if (+state.resultMultiplier < 9.99) {
            return '5x';
          }

          if (+state.resultMultiplier < 99.99) {
            return '10x';
          }

          if (+state.resultMultiplier < 999.99) {
            return '100x';
          }

          return '1000x';
        };
        AudioService.slideStopped(getMultiplierSound());
      }
      return {
        ...state,
        closedRound: true,
      };

    case SlideAction.Reset:
      return {
        ...state,
        round: null,
        closedRound: false,
      };

    case SlideAction.SetSocketConnection: {
      return {
        ...state,
        isSocketConnected: action.payload,
      };
    }
    default:
      return state;
  }
}
